/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import styled from "styled-components";

/**
 * Styled modal content container (div)
 */
export const PaginationRow = styled.div`
  align-items: flex-end;
  border-top: 1px solid #c4c4c4;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 23px;
`;
